var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full mt-48"},[_c('img',{staticClass:"w-full img-450",attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/fabrica-da-moda.appspot.com/o/Banner%2Fmain_banner.jpg?alt=media&token=eb949e69-cd09-4e4c-8a40-0f99875b68c2","alt":"Fábrica da Moda"}})])])
}]

export { render, staticRenderFns }